// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".explanation[data-v-5c74e754]{font-size:14px}.fail-to-receive-explanation[data-v-5c74e754]{max-height:70vh;overflow:auto}", ""]);
// Exports
module.exports = exports;
